import { type PreParsedSectionItemsLinkProps, type PreParsedSectionLinkProps } from '@capsicum/common';
import { useMemo } from 'react';

import { useSetSectionItemsLinks } from './useSetSectionItemsLinks';

const filterItems = (items: Array<PreParsedSectionItemsLinkProps>) => items.filter(item => item.link);

export const useFilterSections = (sections: Array<PreParsedSectionLinkProps>) => {
	const sectionsWithLinks = useSetSectionItemsLinks(sections);

	return useMemo(
		() =>
			sectionsWithLinks
				.map(section => ({
					items: filterItems(section.items as Array<PreParsedSectionItemsLinkProps>),
					title: section.title
				}))
				.filter(section => section.items.length > 0),
		[sectionsWithLinks]
	);
};
